import { defineStyleConfig } from '@chakra-ui/react';

const Input = defineStyleConfig({
  variants: {
    outline: (props) => ({
      field: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
        color: props.colorMode === 'dark' ? '#F9FAFB' : '#1A202C',
        borderColor: props.colorMode === 'dark' ? 'gray.600' : 'gray.400',
        _placeholder: {
          color: props.colorMode === 'dark' ? '#718096' : '#A0AEC0',
        },
        _hover: {
          borderColor: props.colorMode === 'dark' ? 'gray.500' : 'gray.500',
        },
        _focusVisible: {
          borderColor: props.colorMode === 'dark' ? 'brand.orange.500' : 'brand.blue.500',
          boxShadow: props.colorMode === 'dark' ? 'focus_admin' : 'focus',
        },
      },
    }),
  },
  defaultProps: {
    variant: 'outline',
  },
});

export default Input;